
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FanViewer"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"host"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smallAvatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allEvents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventIds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"hasEditPermission"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"EDIT"}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"hasDesignPermission"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"DESIGN"}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"hasManagePermission"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"MANAGE"}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"hasPromotePermission"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"PROMOTE"}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"hasAnyReportPermission"},"name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"GUESTS_REPORT"},{"kind":"EnumValue","value":"ATTENDEES_REPORT"},{"kind":"EnumValue","value":"ORDERS_REPORT"},{"kind":"EnumValue","value":"CHECK_INS_REPORT"},{"kind":"EnumValue","value":"CANCELLATIONS_REPORT"},{"kind":"EnumValue","value":"APPROVALS_REPORT"},{"kind":"EnumValue","value":"AUDIT_REPORT"},{"kind":"EnumValue","value":"TIMESLOTS_REPORT"},{"kind":"EnumValue","value":"SERVICE_INVOICE"}]}},{"kind":"Argument","name":{"kind":"Name","value":"any"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":810}};
    doc.loc.source = {"body":"query FanViewer {\n  viewer {\n    id\n    slug\n    firstName\n    lastName\n    email\n    role\n    locale\n    host\n    smallAvatarUrl\n    memberships {\n      totalCount\n      nodes {\n        id\n        allEvents\n        eventIds\n        hasEditPermission: permission(for:EDIT)\n        hasDesignPermission: permission(for:DESIGN)\n        hasManagePermission: permission(for:MANAGE)\n        hasPromotePermission: permission(for:PROMOTE)\n        hasAnyReportPermission: permissions(\n          for: [\n            GUESTS_REPORT\n            ATTENDEES_REPORT\n            ORDERS_REPORT\n            CHECK_INS_REPORT\n            CANCELLATIONS_REPORT\n            APPROVALS_REPORT\n            AUDIT_REPORT\n            TIMESLOTS_REPORT\n            SERVICE_INVOICE\n          ],\n          any: true\n        )\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["FanViewer"] = oneQuery(doc, "FanViewer");
        
